import { ITransactionOpportunity } from '@sp-types/transactionOpportunityType';
import { GENERAL_ID } from '../../components/Stores/exposureDataStore';
import { Material } from '../../sp-types';

export const getOpportunityTotalQuantity = (data: ITransactionOpportunity[]): number => {
  return data.reduce((acc, transaction) => acc + transaction.quantity, 0);
};
const formatTransactionOpportunitiesWithUndefinedSellIndex = (
  data: ITransactionOpportunity[],
  materialMap: Record<string, Material>,
): ITransactionOpportunity[] => {
  return data.map((item) => ({
    ...item,
    sellByIndex: item.sellByIndex
      ? item.sellByIndex
      : { price: materialMap[item.formulaId]?.currentPrice || 1, date: undefined },
  }));
};
const filterTransactionOpportunityByFormulaId = (
  data: ITransactionOpportunity[],
  formulaId: string,
): ITransactionOpportunity[] => {
  return formulaId === GENERAL_ID ? data : data.filter((item) => item.formulaId === formulaId);
};

export const getUpdatedTransactionOpportunity = (
  data: ITransactionOpportunity[],
  currentFormulaId: string,
  materialsMap: Record<string, Material>,
): ITransactionOpportunity[] => {
  return filterTransactionOpportunityByFormulaId(
    formatTransactionOpportunitiesWithUndefinedSellIndex(data, materialsMap),
    currentFormulaId,
  );
};
export function getPercentageChange(oldValue: number, newValue: number): number {
  const percentageChange = (newValue / oldValue) * 100;
  return percentageChange;
}
export const getOpportunityTotalPrice = (data: ITransactionOpportunity[]): number => {
  return data.reduce((acc, transaction) => acc + transaction.buyByIndex.price * transaction.quantity, 0);
};
export const getTotalProfit = (data: ITransactionOpportunity[]): number => {
  return data.reduce(
    (acc, transaction) =>
      acc + ((transaction.sellByIndex?.price || 0) - transaction.buyByIndex.price) * transaction.quantity,
    0,
  );
};
export const getTotalProfitByRoute = (data: ITransactionOpportunity[]): number => {
  return data.reduce((acc, transaction) => {
    const firstRoute = transaction.routesOptionData[0];
    const transactionPnL = (transaction.sellByIndex?.price || 0) - (transaction.buyByIndex.price || 0);
    if (firstRoute) {
      const routeProfit = (firstRoute.sellingPrice - firstRoute.buyingPrice + transactionPnL) * transaction.quantity;
      return acc + routeProfit;
    }
    return acc;
  }, 0);
};
